import VirtuozzoColorScheme from '@uikit/ui-syntax/dist/js/colors/virtuozzo';

const vzFallbackColorScheme = {
  '--av-app-base': 'rgb(255 255 255)',
  '--av-brand-accent': 'rgba(68, 81, 94, 0.1)',
  '--av-brand-light': 'rgba(68, 81, 94, 0.3)',
  '--av-brand-lightest': 'rgba(68, 81, 94, 0.05)',
  '--av-brand-primary': 'rgba(68, 81, 94, 1)',
  '--av-chart-blue': 'rgba(38, 104, 197, 1)',
  '--av-chart-brown': 'rgba(174, 115, 57, 1)',
  '--av-chart-critical': 'rgba(255, 129, 13, 1)',
  '--av-chart-danger': 'rgba(234, 57, 57, 1)',
  '--av-chart-green': 'rgba(8, 166, 158, 1)',
  '--av-chart-grey': 'rgba(148, 154, 163, 1)',
  '--av-chart-info': 'rgba(64, 139, 234, 1)',
  '--av-chart-light-blue': 'rgba(137, 201, 246, 1)',
  '--av-chart-neutral': 'rgba(222, 224, 227, 1)',
  '--av-chart-purple': 'rgba(206, 120, 243, 1)',
  '--av-chart-red': 'rgba(241, 92, 92, 1)',
  '--av-chart-success': 'rgba(155, 194, 37, 1)',
  '--av-chart-transparent': 'rgba(137, 201, 246, 0.5)',
  '--av-chart-turquoise': 'rgba(36, 174, 226, 1)',
  '--av-chart-violet': 'rgba(111, 91, 149, 1)',
  '--av-chart-warning': 'rgba(255, 193, 7, 1)',
  '--av-chart-yellow': 'rgba(232, 201, 77, 1)',
  '--av-dark': 'rgba(36, 49, 67, 0.9)',
  '--av-fixed-button': 'rgba(68, 81, 94, 1)',
  '--av-fixed-button-light': 'rgba(68, 81, 94, 0.3)',
  '--av-fixed-critical': 'rgba(255, 129, 13, 1)',
  '--av-fixed-critical-accent': 'rgba(254, 237, 217, 1)',
  '--av-fixed-critical-dark': 'rgba(181, 56, 28, 1)',
  '--av-fixed-critical-light': 'rgba(255, 200, 170, 1)',
  '--av-fixed-danger': 'rgba(234, 57, 57, 1)',
  '--av-fixed-danger-accent': 'rgba(255, 236, 236, 1)',
  '--av-fixed-danger-dark': 'rgba(198, 32, 32, 1)',
  '--av-fixed-danger-light': 'rgba(255, 197, 197, 1)',
  '--av-fixed-focus': 'var(--el-secondary-active)',
  '--av-fixed-highlight': 'rgba(255, 223, 0, 1)',
  '--av-fixed-info': 'rgba(64, 139, 234, 1)',
  '--av-fixed-info-accent': 'rgba(236, 243, 253, 1)',
  '--av-fixed-info-dark': 'rgba(31, 86, 162, 1)',
  '--av-fixed-info-light': 'rgba(202, 222, 249, 1)',
  '--av-fixed-invisible': 'rgba(36, 49, 67, 0.1)',
  '--av-fixed-light': 'rgba(36, 49, 67, 0.7)',
  '--av-fixed-lighter': 'rgba(36, 49, 67, 0.4)',
  '--av-fixed-lightest': 'rgba(36, 49, 67, 0.2)',
  '--av-fixed-link-light': 'rgba(199, 203, 207, 1)',
  '--av-fixed-neutral': 'rgba(148, 154, 163, 1)',
  '--av-fixed-neutral-accent': 'rgba(233, 234, 236, 1)',
  '--av-fixed-neutral-dark': 'rgba(92, 102, 115, 1)',
  '--av-fixed-neutral-light': 'rgba(222, 224, 227, 1)',
  '--av-fixed-primary': 'rgba(36, 49, 67, 1)',
  '--av-fixed-secondary': 'rgba(36, 49, 67, 0.9)',
  '--av-fixed-success': 'rgba(155, 194, 37, 1)',
  '--av-fixed-success-accent': 'rgba(245, 249, 233, 1)',
  '--av-fixed-success-dark': 'rgba(64, 112, 9, 1)',
  '--av-fixed-success-light': 'rgba(218, 233, 174, 1)',
  '--av-fixed-warning': 'rgba(255, 193, 7, 1)',
  '--av-fixed-warning-accent': 'rgba(255, 249, 230, 1)',
  '--av-fixed-warning-dark': 'rgba(142, 94, 47, 1)',
  '--av-fixed-warning-light': 'rgba(255, 232, 163, 1)',
  '--av-inversed-invisible': 'rgb(255 255 255 / 10%)',
  '--av-inversed-light': 'rgb(255 255 255 / 70%)',
  '--av-inversed-lighter': 'rgb(255 255 255 / 40%)',
  '--av-inversed-lightest': 'rgb(255 255 255 / 20%)',
  '--av-inversed-primary': 'rgb(255 255 255)',
  '--av-inversed-secondary': 'rgb(255 255 255 / 95%)',
  '--av-light': 'rgb(255 255 255)',
  '--av-nav-primary': 'rgb(38 38 38)',
  '--av-nav-secondary': 'rgba(223, 10, 23, 1)',
  '--av-nav-text': 'rgb(255 255 255)',
  '--av-nav-text-active': 'rgb(255 255 255)',
  '--av-nav-text-light': 'rgb(255 255 255 / 70%)',
  '--av-scroll-thumb': 'rgba(36, 49, 67, 0.4)',
  '--av-scroll-thumb-inverse': 'rgb(255 255 255 / 40%)',
  '--av-solid-brand-accent': 'rgba(236, 238, 239, 1)',
  '--av-solid-brand-lightest': 'rgba(246, 246, 247, 1)',
  '--av-solid-brand-secondary-accent': 'rgba(236, 243, 253, 1)',
  '--av-solid-brand-secondary-light': 'rgba(198, 220, 249, 1)',
  '--av-solid-fixed-invisible': 'rgba(233, 234, 236, 1)',
  '--el-primary-active': 'rgba(41, 49, 56, 1)',
  '--el-primary-hover': 'rgba(54, 65, 75, 1)',
  '--el-secondary-active': 'rgba(68, 81, 94, 0.2)',
  '--el-secondary-hover': 'rgba(68, 81, 94, 0.1)',
  '--el-solid-secondary-active': 'rgba(218, 220, 223, 1)',
  '--av-brand-secondary-active': 'var(--el-secondary-active)',
  '--av-brand-secondary-hover': 'var(--el-secondary-hover)',
  '--av-brand-lighter': 'rgba(68, 81, 94, 0.15)',
  '--av-secondary-hover': 'var(--el-secondary-hover)',
};

const vzOverrides = {
  '--av-fixed-link': 'rgba(68, 81, 94, 1)',
  '--av-brand-secondary': 'rgba(203, 51, 59)',
  '--av-brand-secondary-light': 'rgba(203, 51, 59, 0.30)',
  '--av-brand-secondary-accent': 'rgba(203, 51, 59, 0.15)',
  '--av-brand-primary-hover': 'var(--el-primary-hover)',
  '--av-brand-secondary-active': 'var(--el-secondary-active)',
  '--av-brand-secondary-hover': 'var(--el-secondary-hover)',
  '--av-brand-lighter': 'rgba(68, 81, 94, 0.15)',
  '--av-fixed-focus': 'var(--el-secondary-active)',
  '--av-secondary-hover': 'var(--el-secondary-hover)'
};

// Workaround for old browsers that don't support oklch
if (typeof CSS !== 'undefined' && !CSS.supports('color', 'oklch(50% 0.1 120)')) {
  Object.entries(VirtuozzoColorScheme as Record<string, string>).forEach(([key, value]) => {
    if (value.startsWith('oklch') && !vzOverrides[key]) {
      vzOverrides[key] = vzFallbackColorScheme[key];
    }
  });
}

export default {
  ...vzFallbackColorScheme,
  ...vzOverrides,
};
